var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4411 6.21575C16.7683 6.21575 16.2228 5.67 16.2228 4.99725V1.25H5.02684C4.35409 1.25 3.80859 1.7955 3.80859 2.4685V22.5315C3.80859 23.2043 4.35409 23.75 5.02684 23.75H19.9696C20.6423 23.75 21.1883 23.2043 21.1883 22.5315V6.21575H17.4411Z",
    fill: "#8DC63F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4412 6.21575H21.1887L16.2227 1.25V4.99725C16.2227 5.67025 16.7682 6.21575 17.4412 6.21575Z",
    fill: "#8DC63F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.6,
    d: "M17.4412 6.21575H21.1887L16.2227 1.25V4.99725C16.2227 5.67025 16.7682 6.21575 17.4412 6.21575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.16968 14.7638C6.84188 14.7638 6.61328 14.9985 6.61328 15.3384C6.61328 15.6661 6.84188 15.9071 7.15732 15.9071H7.16384C7.49747 15.9071 7.71955 15.6661 7.71955 15.3384C7.71337 14.9924 7.49061 14.7638 7.16968 14.7638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.5995 11.6736H10.5241L10.172 12.4339C10.067 12.6749 9.98663 12.8602 9.88744 13.1262H9.87508C9.77623 12.8914 9.68321 12.6876 9.55998 12.4339L9.19512 11.6736H8.11356L9.27578 13.7317L8.07031 15.8392H9.14569L9.4855 15.0851C9.62142 14.7947 9.72646 14.5785 9.8133 14.3375H9.82531C9.9427 14.5785 10.0419 14.7947 10.196 15.0851L10.5732 15.8392H11.661L10.4246 13.707L11.5995 11.6736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.1738 11.6736H12.2344V15.8389H14.83V15.048H13.1738V11.6736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.0695 13.3668C16.5258 13.1567 16.2972 13.0393 16.2972 12.7733C16.2972 12.5632 16.4949 12.3714 16.9026 12.3714C17.3042 12.3714 17.6073 12.4891 17.768 12.5691L17.9777 11.8153C17.7305 11.6979 17.3907 11.6053 16.9147 11.6053C15.9381 11.6053 15.3388 12.1428 15.3388 12.8533C15.3388 13.4653 15.796 13.8483 16.4884 14.0955C16.9888 14.2688 17.1865 14.4233 17.1865 14.6766C17.1865 14.955 16.9579 15.1338 16.5254 15.1338C16.1235 15.1338 15.7281 15.004 15.4809 14.8743L15.2891 15.6466C15.5238 15.7767 15.9937 15.9064 16.4695 15.9064C17.6125 15.9064 18.1442 15.313 18.1442 14.6148C18.1445 14.022 17.8047 13.6386 17.0695 13.3668Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsIcon);
export default __webpack_public_path__ + "static/media/xls-icon.200df5db741a1de63bfd8631e458bc1f.svg";
export { ForwardRef as ReactComponent };